// @flow
import styled, { css } from "styled-components";

export const MoneyBlock = styled.div`
  display: flex;
  margin: 0 5px;
  font-weight: 700;
  font-size: ${props => props.size || "14px"};
  
  @media (max-width: 959px) {
    ${props => props.size === "24px" && css`
      font-size: 20px;
    `};
  }
  
  @media (max-width: 479px) {
    ${props => props.size === "24px" && css`
      font-size: 18px;
    `};
  }
`;

export const MoneyValue = styled.div`
  margin: 0 2px;
  color: ${({ theme }) => theme.foreground};
`;

export const MoneyCurrency = styled.div`
  margin: 0 2px;
  color: ${({ theme }) => theme.accent};
`;



// WEBPACK FOOTER //
// ./src/components/Tournament/Money.js